import React, { useState } from "react";

import { Carousel } from "react-responsive-carousel"; // https://www.npmjs.com/package/react-responsive-carousel

import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../css/ReadMore.css";

/**
 * Dot navigation for mobile
 * @param integer index
 * @param integer pageCurrent
 * @param function onSelectDot(index)
 */
const ReadMoreDot = props => {
  const pageDot = props.index + 1;
  const onClickHandler = () => {
    if (pageDot === props.pageCurrent) return;
    props.onSelectDot(pageDot);
  };
  return (
    <button
      key={pageDot}
      onClick={onClickHandler}
      className={pageDot === props.pageCurrent ? "dot-fill" : "dot-empty"}
    ></button>
  );
};

/**
 * Display the section Read more
 * @param array news : List of news { string title, string category, string text, string image}
 * @returns
 */
const ReadMore = props => {
  const news = props.news ?? [];
  const [pageCurrent, setPageCurrent] = useState(1);

  if (news.length === 0) {
    return <></>;
  }

  //Callback change Carousel
  const onChangeCarouselHandler = (index, menu) => {
    setPageCurrent(index + 1);
  };

  // Part of controls button
  const onClickCarousselActionPrevHandler = () => {
    setPageCurrent(page => {
      const nextPage = page - 1;
      return nextPage <= 1 ? 1 : nextPage;
    });
  };

  const onClickCarousselActionNextHandler = () => {
    setPageCurrent(page => {
      const nextPage = page + 1;
      return nextPage <= news.length ? nextPage : page;
    });
  };

  // Selection of the news for mobile
  const onSelectDotHandler = indexPageSelect => {
    setPageCurrent(indexPageSelect);
  };

  const actionMenu = (
    <>
      <div className="w-100 dn db-ns">
        <div className="actions flex justify-end">
          <button disabled={1 === pageCurrent ? true : false} onClick={onClickCarousselActionPrevHandler}>
            {"<"}
          </button>
          <div className="tc pv2 ph3 flex items-center justify-center">
            {pageCurrent} / {news.length}
          </div>
          <button disabled={news.length === pageCurrent ? true : false} onClick={onClickCarousselActionNextHandler}>
            {">"}
          </button>
        </div>
      </div>
      <div className="dn-ns w-100 tc actions-mobile flex justify-center">
        {news.map((menu, index) => {
          return <ReadMoreDot key={index} index={index} pageCurrent={pageCurrent} onSelectDot={onSelectDotHandler} />;
        })}
      </div>
    </>
  );

  // return JSX
  return (
    <section className="section-readmore pv5">
      <div>
        <div className="title">{props.title}</div>
        <Carousel
          showThumbs={false}
          swipeable={true}
          emulateTouch={true}
          showIndicators={false}
          showStatus={false}
          showArrows={false}
          onChange={onChangeCarouselHandler}
          autoPlay={true}
          interval={10000}
          infiniteLoop={true}
          selectedItem={pageCurrent - 1}
        >
          {news.map((menu, index) => {
            const linkBgImage = `url("/images/${menu.image}")`;

            return (
              <div className="news cf" key={index}>
                <div className="fl w-100 w-50-ns cover bg-center" style={{ backgroundImage: linkBgImage }}></div>
                <div className="fl w-100 w-50-ns bg-white pa4 flex flex-column">
                  <div className="category">{menu.category}</div>
                  <div className="title">{menu.title}</div>
                  <div className="textnews overflow-y-auto pt3 dn db-ns">{menu.text}</div>
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
      {news.length > 1 && actionMenu}
    </section>
  );
};

export default ReadMore;
